module.exports = __webpack_public_path__ + "img/new_28_1.993f9c9c.jpg";